// Hooks
import {
    REMOVE_PERIOD_SELECTED,
    UPDATE_PERIOD_SELECTED,
    useAlbumContext
} from '@/utils/hooks/context/useAlbumContext';
import useTranslation from '@/utils/hooks/translation/useTranslation';

import Icon from '@/components/base/Icon';
// Components
import Label from '@/components/base/Label';
import DatepickerAlbums from '@/components/composite/Datepicker/DatepickerAlbums';

const DatepickerFilter = () => {
    const { t } = useTranslation('content');
    const { albumInfo, dispatch } = useAlbumContext();

    function updatePeriod(date) {
        dispatch({
            type: UPDATE_PERIOD_SELECTED,
            payload: date
        });
    }

    function removePeriod() {
        dispatch({
            type: REMOVE_PERIOD_SELECTED
        });
    }

    return (
        <div>
            <Label className="flex items-center space-x-2.5 pb-2">
                <Icon icon="calendar" className="text-sm text-icoBlue" />
                <span className="text-icoBlack dark:text-white">{t('modal.period')}</span>
            </Label>
            <DatepickerAlbums
                periodSelected={
                    albumInfo?.criteria?.started_at && albumInfo?.criteria?.ended_at
                        ? [
                              albumInfo?.criteria?.started_at ?? '',
                              albumInfo?.criteria?.ended_at ?? ''
                          ]
                        : ''
                }
                setPeriodSelected={updatePeriod}
                removePeriod={removePeriod}
                placeholder={t('modal.edit_modal.filter_on_period')}
                inputStyle="datepicker"
                noBorderShadow={false}
            />
        </div>
    );
};

export default DatepickerFilter;
